import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "@/lib/api";

const StatusCtx = createContext(null);

export function StatusProvider({ children }) {
  const [statuses, setStatuses] = useState([]);

  const reload = useCallback(
    () => api.get("/statuses").then((r) => setStatuses(r.data)).catch(() => {}),
    []
  );
  useEffect(() => {
    reload();
  }, [reload]);

  const map = Object.fromEntries(statuses.map((s) => [s.key, s]));
  const label = (key, lang = "en") => map[key]?.labels?.[lang] || map[key]?.labels?.en || key;
  const color = (key) => map[key]?.color || "#a1a1aa";
  const closes = (key) => !!map[key]?.closes_case;

  return (
    <StatusCtx.Provider value={{ statuses, map, label, color, closes, reload }}>
      {children}
    </StatusCtx.Provider>
  );
}

export const useStatuses = () => useContext(StatusCtx);

// Inline style for a status pill from a hex color (adds alpha for bg/border).
export const statusBadgeStyle = (hex) => ({
  color: hex,
  borderColor: `${hex}66`,
  backgroundColor: `${hex}1a`,
});
